export const INVOICE_OPTIONS = [
    'ADD IN INVOICE',
    "DON'T ADD IN INVOICE",
    "DON'T CALCULATE CHARGE"
] as const;

export interface AwbStatus {
    _id: string;
    name: string;
    code: string;
    status: 'Active' | 'Inactive';
    invoice: typeof INVOICE_OPTIONS[number];
    createdAt: string;
    updatedAt: string;
    createdBy?: string;
    updatedBy?: string;
}

export interface AwbStatusFormData {
    name: string;
    code: string;
    status: 'Active' | 'Inactive';
    invoice: string;
}

export interface AwbStatusFilters {
    status?: string;
    invoice?: string;
}

export interface AwbStatusSearchParams {
    search?: string;
    filters?: AwbStatusFilters;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
}

export interface AwbStatusApiResponse {
    success: boolean;
    data: AwbStatus[] | {
        data: AwbStatus[];
        total: number;
        page: number;
        limit: number;
        totalPages: number;
    };
    message?: string;
    timestamp?: string;
}


